import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const maxValueValidator =
    (maxValue: number, message: string): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
        if (!control.value || !Number(maxValue) || !Number(control.value)) {
            return null;
        }
        if (Number(control.value) > maxValue) {
            return {
                maxValue: message
            };
        }
        return null;
    };
